import { render, staticRenderFns } from "./MudarIncremento.vue?vue&type=template&id=07f752c8&"
import script from "./MudarIncremento.vue?vue&type=script&lang=js&"
export * from "./MudarIncremento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports